import { T } from "@/locales";

export default [
  {
    title: T("序号"),
    dataIndex: "index",
    fixed: "left",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("入库通知单号"),
    dataIndex: "receipt_order_number",
    fixed: "left",
    width: 180,
    ellipsis: true,
    scopedSlots: { customRender: "number" },
  },
  {
    title: T("创建时间"),
    dataIndex: "create_time",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("创建人"),
    dataIndex: "creator_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("货品名称"),
    dataIndex: "material_name",
    width: 240,
    ellipsis: true,
  },
  {
    title: T("货品编号"),
    dataIndex: "material_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("入库数量"),
    dataIndex: "total_quantity",
    width: 100,
    ellipsis: true,
  },
  {
    title: T("入库重量(吨)"),
    dataIndex: "total_weight",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("入库面积(平方米)"),
    dataIndex: "total_area",
    width: 140,
    ellipsis: true,
  },
  {
    title: T("入库体积(立方米)"),
    dataIndex: "total_volume",
    width: 140,
    ellipsis: true,
  },
  {
    title: T("批次编号"),
    dataIndex: "batch_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("仓库"),
    dataIndex: "warehouse_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("订单类型"),
    dataIndex: "order_type_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("往来单位单号"),
    dataIndex: "external_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("货主"),
    dataIndex: "client_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("规格"),
    dataIndex: "material_spec",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("单价"),
    dataIndex: "unit_price",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("到货日期"),
    dataIndex: "arrival_date",
    width: 120,
    ellipsis: true,
  },

  // {
  //   title: T("总重量(吨)"),
  //   dataIndex: "total_weight",
  //   width: 120,
  //   ellipsis: true,
  //   customRender: (value, item) => {
  //     if (item.total_weight) {
  //       return NP.times(item.total_weight, 0.001);
  //     }
  //   },
  // },
  // {
  //   title: T("序列号"),
  //   dataIndex: "serial_number_list",
  //   width: 160,
  //   customRender: (value) => value.join(","),
  // },
  {
    title: T("托盘尺寸"),
    dataIndex: "pallet_size",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("备注"),
    dataIndex: "remark",
    width: 240,
    ellipsis: true,
  },
];
